import { FinalIcon } from 'assets/svg';
import { Layout } from 'components/Layout/Layout';

import S from './FinalScreen.styleld';

export const FinalScreen = () => {
  return (
    <Layout isLeftLogoHidden style={{ background: '#fff' }}>
      <S.Wrapper>
        <FinalIcon />
        <p className="title">Thank you for participation!</p>
        <p>Please check your email </p>
      </S.Wrapper>
    </Layout>
  );
};
